export const SET_FETCH_DEPLOYED_REGIONS_REQUEST = 'SET_FETCH_DEPLOYED_REGIONS_REQUEST';
export const SET_FETCH_DEPLOYED_REGIONS_SUCCESS = 'SET_FETCH_DEPLOYED_REGIONS_SUCCESS';
export const SET_FETCH_DEPLOYED_REGIONS_ERROR = 'SET_FETCH_DEPLOYED_REGIONS_ERROR';

